import React, { Component, PropTypes } from 'react';
import ModalClose from '../../icons/ModalClose';
import './Modal.css';

class Modal extends Component {

  render() {
    return (
      <div className={`modal ${this.props.className}`}>
        <div className="modal__center" >
					<ModalClose onClick={this.props.handleCloseClick} />
          {this.props.title &&
            <h2 className="modal__title">{this.props.title}</h2>
          }
          {this.props.children}
          { this.props.footerMessage &&
            <span className="modal__type">{this.props.footerMessage}</span>
          }
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  handleCloseClick: PropTypes.func.isRequired,
	title: PropTypes.string
};

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/index.js
 **/